import axios from '../index';

import { PaginationRequest, PaginationResult, ResponseResult, Url } from "../Common/Util";
import { MovementItemResponse, MovementResponse, MovementStateLog } from "./Entities/InventoryMovementEntities";

const GetUrl = Url("api/v1/Inventory/Movement");

export default {
    GetById,
    GetMoves,
    InventoryItemHistory,
    StateHistory,
    PriorProtocolDispenses
}

async function PriorProtocolDispenses({ relatedId, currentSequenceNumber, currentMovementId, signal } = {}) {
    const response = await axios.get(GetUrl('/PriorProtocolDispenses'), {
        params: {
            relatedId,
            currentSequenceNumber,
            currentMovementId
        },
        signal
    })
    return new ResponseResult(response.data)
}

async function GetById(moveId) {
    const response = await axios.get(GetUrl(`/${moveId}`))
    const move = new MovementResponse(response.data.value)
    move.items = move.items.map(i => new MovementItemResponse(i))
    return new ResponseResult({ ...response.data, value: move })
}

async function GetMoves({ pageNumber, pageSize, sortColumn, sortOrder, includedTypes = null, status = null, assignmentTypes = null, userId = null, assignId = null } = {}) {
    const response = await axios.get(GetUrl(''), {
        params: { ...new PaginationRequest({ pageNumber, pageSize, sortColumn, sortOrder }), includedTypes, status, assignmentTypes, userId, assignId }
    })
    const data = new PaginationResult(response.data)
    data.Values = data.Values.map(m => new MovementResponse(m))
    return data;
}

async function InventoryItemHistory({ itemId, pageNumber, pageSize }) {
    const response = await axios.get(GetUrl(`/InventoryItemHistory/${itemId}`), {
        params: { ...new PaginationRequest({ pageNumber, pageSize }), itemId }
    })
    const data = new PaginationResult(response.data)
    data.Values = data.Values.map(m => new MovementResponse(m))
    return data;
}

async function StateHistory({ moveId: id }) {
    const response = await axios.get(GetUrl(`/${id}/StateHistory`))
    const data = new ResponseResult(response.data)
    data.Value = data.Value.map(m => new MovementStateLog(m))
    return data;
}